import { Input, message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { Button, FormItem } from 'components';
import Divider from 'containers/DriverPortalPage/components/Divider';
import DriverPortalLayout from 'containers/DriverPortalPage/components/DriverPortalLayout';
import HeaderPortal from 'containers/DriverPortalPage/MainPage/components/HeaderPortal';
import ReturnButton from 'containers/DriverPortalPage/MainPage/components/ReturnButton';
import { useFormik } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import {
  addressService,
  authenticationService,
  mainService,
} from 'services/driverPortal';
import { useQueryParams } from '../../../../hooks';
import { getCurrentDate } from '../../../../utils/dateUtils';
import { isPdfFile } from '../../../../utils/isFilePdf';
import UploadImageForm from '../../MainPage/components/UploadImageForm';
import Information from '../components/Information';

interface IOnlineTrainingCertificateImage {
  image?: string;
  linkUrl?: string;
  createdAt?: string;
  isAllowConsent?: boolean;
}

interface IOnlineTrainingCertificateRequest {
  document: IOnlineTrainingCertificateImage;
  status?: string;
}

interface IOnlineTrainingCertificateImageUpload {
  document?: FormData;
}

const folderType = 'onlinetraining-certificate';

export interface IOnlineTrainingPageProps {}
const OnlineTrainingPage: React.FC<IOnlineTrainingPageProps> = () => {
  const { userId, accessToken } = authenticationService.getUserToken();
  const [filesToUpload, setFilesToUpload] = useState<
    IOnlineTrainingCertificateImageUpload
  >({});
  const { search, pushUrl } = useQueryParams();
  const [disableEdit, setDisableEdit] = useState(false);
  const [imageDeletionFiles, setImageDeletionFiles] = useState<UploadFile[]>(
    [],
  );
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [onlineTrainingFileName, setOnlineTrainingFileName] = useState<string>(
    '',
  );

  const goToMainPage = () => {
    pushUrl('/', search);
  };

  useEffect(() => {
    const { accessToken } = authenticationService.getUserToken() || {};
    if (!accessToken) {
      pushUrl('/login', search);
    }
  }, [pushUrl, search]);

  const loadImage = async (path: string) => {
    try {
      const response = await mainService.loadImageAxios(path);
      return response;
    } catch (e) {
      return null;
    }
  };

  const buildPayloadOnlineTraining = async (
    values: IOnlineTrainingCertificateRequest,
  ) => {
    const f = values ?? {};

    const fd = new FormData();
    fd.append('tab', 'online_assessment');
    if (filesToUpload.document?.get('files')) {
      fd.append(
        'onlineAssessmentImage',
        filesToUpload.document?.get('files') ?? '',
      );
    }
    fd.append('linkUrl', f.document.linkUrl || '');
    return fd;
  };

  const handleRemoveImage = useCallback(
    (file: UploadFile) => {
      if (!file.fileName?.match(/^blob\:/)) {
        setImageDeletionFiles([...imageDeletionFiles, file]);
        setOnlineTrainingFileName('');
      }
    },
    [imageDeletionFiles],
  );

  const formik = useFormik<IOnlineTrainingCertificateRequest>({
    initialValues: {
      document: {
        image: undefined,
        createdAt: undefined,
      },
    },
    enableReinitialize: true,
    onSubmit: async formValues => {
      if (saveLoading) return;
      setSaveLoading(true);
      if (formValues.document.image !== undefined) {
        const createdAt = getCurrentDate();
      }

      const payload = await buildPayloadOnlineTraining(formValues);

      const res = await addressService.updateInfo(payload);

      // const response = await mutationVaccinationCertificate({
      //   ...formValues,
      //   status: 'submitted',
      // });

      const uploadImageErrors = [];

      // if (isAllowConsent && imageDeletionFiles.length > 0) {
      //   const imageDeleteFiles = await updateByFiles(imageDeletionFiles);
      //   if (imageDeleteFiles.error) uploadImageErrors.push(imageDeleteFiles);
      // }

      // if (res?. === STATUS_RESPONSE.UNAUTHORIZED) {
      //   await authenticationService.logout();
      //   goToLoginPage();
      // }

      if (res?.errorMessageList) {
        // transformMutationResponseError(res?.payload as any);
      }

      if (res?.success === true) {
        message.success('บันทึกข้อมูลเรียบร้อยแล้ว');
        goToMainPage();
        setSaveLoading(false);
      }
    },
  });

  const getInfo = async () => {
    try {
      const response = await mainService.getInfo();
      // const response = mainService.getMockPotentialLead(id);
      if (response?.data?.potentialLeadOnlineAssessment) {
        const infoData = response.data.potentialLeadOnlineAssessment;
        setIsApproved(infoData.statusCode === 'approved');

        if (infoData?.onlineAssessmentImage) {
          const image = await loadImage(infoData?.onlineAssessmentImage);
          setOnlineTrainingFileName(infoData.onlineAssessmentImage);
          formik.setFieldValue('document', {
            image: image ? image.url : undefined,
          });
        }
        formik.setFieldValue('document.linkUrl', infoData.linkUrl || '');
      }
    } catch (e) {
      console.log('===== Debug error status: ', e.toString());
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  const errors = formik.errors || {};

  const typeformUrl = process.env.REACT_APP_TYPEFORM_URL || '';
  const goToTypeForm = () => {
    window.open(`${typeformUrl}#user_id=${userId}`, '_self');
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <HeaderPortal />
        <DriverPortalLayout>
          {/*{loading && <Loading />}*/}
          <ReturnButton />
          <Information
            title="อบรมออนไลน์"
            description='กรุณากรอกข้อมูล และอัพโหลดเอกสาร แล้วกด "บันทึก"'
          />

          <div
            style={{
              backgroundColor: '#EDFBFF',
              border: '1px solid #D7F4FF',
              borderRadius: 8,
              padding: '20px 24px',
              marginTop: -15,
              color: '#444',
              fontSize: 13,
              lineHeight: 1.6,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>
              การเข้าสู่ระบบ ALL NOW LMS เพื่ออบรมออนไลน์
            </div>

            <div>
              1. เข้าสู่เว็บไซต์{' '}
              <a
                href="https://lms.allnowgroup.com/login"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: '#1677ff',
                  textDecoration: 'underline',
                }}
              >
                lms.allnowgroup.com/login
              </a>
            </div>
            <div>
              2. หน้าเข้าสู่ระบบให้ใส่ Username และ Password
              เป็นเบอร์โทรศัพท์ที่ใช้สมัคร
            </div>
            <div>3. กดปุ่มเข้าสู่ระบบ และทำการอบรมออนไลน์</div>
          </div>

          <Divider />

          <FormItem
            required
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={errors.document?.image ? 'error' : ''}
            help={errors?.document?.image}
          >
            <UploadImageForm
              disabled={disableEdit || isApproved}
              title="อัพโหลดใบ Certificate"
              required
              bulletList={[
                'ไม่แก้ไขและตกแต่งรูป',
                'เห็นข้อมูลชัดเจนและครบถ้วน',
              ]}
              onChange={value => {
                const files = value.uploadFileForm
                  ? (value.uploadFileForm.get('files') as Blob)
                  : '';
                setFilesToUpload({
                  ...filesToUpload,
                  document: value.uploadFileForm,
                });
                formik.setFieldValue('document', {
                  image: files ? URL.createObjectURL(files) : undefined,
                });
              }}
              pathImage={formik.values.document.image}
              nameImage="ใบ Certificate"
              onRemove={handleRemoveImage}
              folder={folderType}
              isPdf={isPdfFile(onlineTrainingFileName)}
              fileName={onlineTrainingFileName}
            />
          </FormItem>
          <FormItem
            label="Link URL ใบ Certificate"
            labelCol={{ span: 24 }}
            colon={false}
          >
            <Input
              disabled={disableEdit || isApproved}
              size="large"
              name="citizen.id"
              placeholder="Link URL ของ ใบ Certificate"
              // onChange={formik.handleChange}
              onChange={e => {
                formik.setFieldValue('document.linkUrl', e.target.value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.document?.linkUrl}
            />
          </FormItem>

          <Divider />

          <Button
            block
            type={disabledSubmit || isApproved ? 'default' : 'primary'}
            size="large"
            disabled={disabledSubmit || isApproved}
            htmlType="submit"
            loading={saveLoading}
          >
            บันทึก
          </Button>
        </DriverPortalLayout>
        {/*{formDirty && <ConfirmReturnModal isShow={isShowModal} />}*/}
      </form>
    </>
  );
};

export default OnlineTrainingPage;
